import { useEffect } from 'react'

export const useComponentDidMount = (fn: () => void | Promise<void>) => {
  useEffect(() => {
    fn()
  }, [])
}

export const useRawComponentDidMount = (fn: () => undefined | (() => void)) => {
  useEffect(() => {
    return fn()
  }, [])
}
